// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { ActivatePopupData, ActivatePopupErrors, ActivatePopupResponses, AddScopeToUserData, AddScopeToUserErrors, AddScopeToUserResponses, AddUserRightToMandateData, AddUserRightToMandateErrors, AddUserRightToMandateResponses, ChangeExpiredPasswordData, ChangeExpiredPasswordErrors, ChangeExpiredPasswordResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ChangePasswordWithCodeData, ChangePasswordWithCodeErrors, ChangePasswordWithCodeResponses, CheckPasswordData, CheckPasswordErrors, CheckPasswordResponses, CreateAudienceTemplateData, CreateAudienceTemplateErrors, CreateAudienceTemplateResponses, CreateEmailMfaMethodData, CreateEmailMfaMethodErrors, CreateEmailMfaMethodResponses, CreateMandateData, CreateMandateErrors, CreateMandateResponses, CreateMessageData, CreateMessageErrors, CreateMessageResponses, CreatePopupData, CreatePopupErrors, CreatePopupResponses, CreateRightData, CreateRightErrors, CreateRightResponses, CreateTemplateData, CreateTemplateErrors, CreateTemplateResponses, CreateTotpMfaMethodData, CreateTotpMfaMethodErrors, CreateTotpMfaMethodResponses, CreateUserData, CreateUserErrors, CreateUserResponses, DeactivatePopupData, DeactivatePopupErrors, DeactivatePopupResponses, DeleteAudienceTemplateData, DeleteAudienceTemplateErrors, DeleteAudienceTemplateResponses, DeleteMessageData, DeleteMessageErrors, DeleteMessageResponses, DeleteMfaMethodData, DeleteMfaMethodErrors, DeleteMfaMethodResponses, DeleteNotificationData, DeleteNotificationErrors, DeleteNotificationResponses, DeletePspDocumentData, DeletePspDocumentErrors, DeletePspDocumentResponses, DeleteRightData, DeleteRightErrors, DeleteRightResponses, DeleteTemplateData, DeleteTemplateErrors, DeleteTemplateResponses, DeleteUploadData, DeleteUploadErrors, DeleteUploadResponses, DeleteUserData, DeleteUserErrors, DeleteUserResponses, DownloadFileData, DownloadFileErrors, DownloadFileResponses, DownloadPspDocumentData, DownloadPspDocumentErrors, DownloadPspDocumentResponses, DownloadTemplateData, DownloadTemplateErrors, DownloadTemplateResponses, DownloadUploadData, DownloadUploadErrors, DownloadUploadResponses, EndImpersonationData, EndImpersonationErrors, EndImpersonationResponses, ExpireOwnPasswordData, ExpireOwnPasswordErrors, ExpireOwnPasswordResponses, FreshUntilData, FreshUntilErrors, FreshUntilResponses, GenerateUserPasswordData, GenerateUserPasswordErrors, GenerateUserPasswordResponses, GetAllPspDocumentCountData, GetAllPspDocumentCountErrors, GetAllPspDocumentCountResponses, GetAllPspDocumentsData, GetAllPspDocumentsErrors, GetAllPspDocumentsPageData, GetAllPspDocumentsPageErrors, GetAllPspDocumentsPageResponses, GetAllPspDocumentsResponses, GetAttendanceByIdData, GetAttendanceByIdErrors, GetAttendanceByIdResponses, GetAttendanceVersionsData, GetAttendanceVersionsErrors, GetAttendanceVersionsResponses, GetAudienceMandatesPageData, GetAudienceMandatesPageErrors, GetAudienceMandatesPageResponses, GetAudienceTemplateData, GetAudienceTemplateErrors, GetAudienceTemplateResponses, GetAudienceTemplatesData, GetAudienceTemplatesErrors, GetAudienceTemplatesResponses, GetAvailableAttendanceMonthsData, GetAvailableAttendanceMonthsErrors, GetAvailableAttendanceMonthsResponses, GetAvailableGiustificativiData, GetAvailableGiustificativiErrors, GetAvailableGiustificativiResponses, GetAvailableVociData, GetAvailableVociResponses, GetCalendarEntriesData, GetCalendarEntriesErrors, GetCalendarEntriesResponses, GetCircularLetterPdfData, GetCircularLetterPdfErrors, GetCircularLetterPdfResponses, GetCircularLettersData, GetCircularLettersErrors, GetCircularLettersResponses, GetCurrentAttendanceData, GetCurrentAttendanceErrors, GetCurrentAttendanceResponses, GetDevicesData, GetDevicesErrors, GetDevicesResponses, GetFolderRightsData, GetFolderRightsErrors, GetFolderRightsResponses, GetHealthHealthPingGetData, GetHealthHealthPingGetErrors, GetHealthHealthPingGetResponses, GetLanguagesLanguageLanguagesGetData, GetLanguagesLanguageLanguagesGetErrors, GetLanguagesLanguageLanguagesGetResponses, GetMandateByIdData, GetMandateByIdErrors, GetMandateByIdResponses, GetMandateCountData, GetMandateCountErrors, GetMandateCountResponses, GetMandatesData, GetMandatesErrors, GetMandatesResponses, GetMandateStructureData, GetMandateStructureErrors, GetMandateStructureResponses, GetMessageAdminCountData, GetMessageAdminCountErrors, GetMessageAdminCountResponses, GetMessageByIdData, GetMessageByIdErrors, GetMessageByIdResponses, GetMessageCountData, GetMessageCountErrors, GetMessageCountResponses, GetMessagesAdminData, GetMessagesAdminErrors, GetMessagesAdminResponses, GetMessagesData, GetMessagesErrors, GetMessagesResponses, GetMfaMethodsData, GetMfaMethodsErrors, GetMfaMethodsResponses, GetMyMandatesData, GetMyMandatesErrors, GetMyMandatesResponses, GetMyUploadCountData, GetMyUploadCountErrors, GetMyUploadCountResponses, GetMyUploadsData, GetMyUploadsErrors, GetMyUploadsPageData, GetMyUploadsPageErrors, GetMyUploadsPageResponses, GetMyUploadsResponses, GetNotificationsData, GetNotificationsErrors, GetNotificationsResponses, GetOriginalAttendanceData, GetOriginalAttendanceErrors, GetOriginalAttendanceResponses, GetPasswordPolicyData, GetPasswordPolicyErrors, GetPasswordPolicyResponses, GetPopupData, GetPopupErrors, GetPopupImageData, GetPopupImageErrors, GetPopupImageResponses, GetPopupResponses, GetPopupsData, GetPopupsErrors, GetPopupsResponses, GetPopupsToDisplayData, GetPopupsToDisplayErrors, GetPopupsToDisplayResponses, GetPspDocumentCountData, GetPspDocumentCountErrors, GetPspDocumentCountResponses, GetPspDocumentsData, GetPspDocumentsErrors, GetPspDocumentsPageData, GetPspDocumentsPageErrors, GetPspDocumentsPageResponses, GetPspDocumentsResponses, GetRightData, GetRightErrors, GetRightResponses, GetRightsData, GetRightsErrors, GetRightsResponses, GetSettingsAdminSettingsGetData, GetSettingsAdminSettingsGetErrors, GetSettingsAdminSettingsGetResponses, GetTagsData, GetTagsErrors, GetTagsResponses, GetTemplateCountData, GetTemplateCountErrors, GetTemplateCountResponses, GetTemplateData, GetTemplateErrors, GetTemplateResponses, GetTemplatesData, GetTemplatesErrors, GetTemplatesResponses, GetUnreadNotificationCountData, GetUnreadNotificationCountErrors, GetUnreadNotificationCountResponses, GetUploadCountData, GetUploadCountErrors, GetUploadCountResponses, GetUploadFilesSummaryAdminUploadFilesSummaryGetData, GetUploadFilesSummaryAdminUploadFilesSummaryGetErrors, GetUploadFilesSummaryAdminUploadFilesSummaryGetResponses, GetUploadLimitsData, GetUploadLimitsErrors, GetUploadLimitsResponses, GetUploadsData, GetUploadsErrors, GetUploadsPageData, GetUploadsPageErrors, GetUploadsPageResponses, GetUploadsResponses, GetUserByIdData, GetUserByIdErrors, GetUserByIdResponses, GetUserCountData, GetUserCountErrors, GetUserCountResponses, GetUserMeData, GetUserMeErrors, GetUserMeResponses, GetUserRightsByMandateIdData, GetUserRightsByMandateIdErrors, GetUserRightsByMandateIdResponses, GetUsersData, GetUsersErrors, GetUsersPageData, GetUsersPageErrors, GetUsersPageResponses, GetUsersResponses, ImpersonateUserData, ImpersonateUserErrors, ImpersonateUserResponses, ImportArxivarData, ImportArxivarDocumentsData, ImportArxivarDocumentsErrors, ImportArxivarDocumentsResponses, ImportArxivarEmployeesData, ImportArxivarEmployeesErrors, ImportArxivarEmployeesResponses, ImportArxivarErrors, ImportArxivarMandatesData, ImportArxivarMandatesErrors, ImportArxivarMandatesResponses, ImportArxivarResponses, ImportArxivarUsersData, ImportArxivarUsersErrors, ImportArxivarUsersResponses, ImportAttendanceData, ImportAttendanceEmailsData, ImportAttendanceEmailsErrors, ImportAttendanceEmailsResponses, ImportAttendanceErrors, ImportAttendanceResponses, ImportCircularLettersData, ImportCircularLettersErrors, ImportCircularLettersResponses, ImportPspDocumentsData, ImportPspDocumentsErrors, ImportPspDocumentsResponses, IsRightDeletableData, IsRightDeletableErrors, IsRightDeletableResponses, IsUploadDeletableData, IsUploadDeletableErrors, IsUploadDeletableResponses, LoginData, LoginErrors, LoginResponses, LoginSsoData, LoginSsoErrors, LoginSsoResponses, MandateRightsUserMandateRightsUserIdGetData, MandateRightsUserMandateRightsUserIdGetErrors, MandateRightsUserMandateRightsUserIdGetResponses, MarkAllNotificationsAsReadData, MarkAllNotificationsAsReadErrors, MarkAllNotificationsAsReadResponses, MarkNotificationsAsReadData, MarkNotificationsAsReadErrors, MarkNotificationsAsReadResponses, MarkNotificationsAsUnReadData, MarkNotificationsAsUnReadErrors, MarkNotificationsAsUnReadResponses, MarkPopupAsViewedData, MarkPopupAsViewedErrors, MarkPopupAsViewedResponses, PasswordResetCodeIsValidData, PasswordResetCodeIsValidErrors, PasswordResetCodeIsValidResponses, PatchAudienceTemplateData, PatchAudienceTemplateErrors, PatchAudienceTemplateResponses, PatchDeviceData, PatchDeviceErrors, PatchDeviceResponses, PatchMandateData, PatchMandateErrors, PatchMandateResponses, PatchMessageData, PatchMessageErrors, PatchMessageResponses, PatchMfaMethodData, PatchMfaMethodErrors, PatchMfaMethodResponses, PatchPopupData, PatchPopupErrors, PatchPopupResponses, PatchRightData, PatchRightErrors, PatchRightResponses, PatchUserAdminData, PatchUserAdminErrors, PatchUserAdminResponses, PatchUserData, PatchUserErrors, PatchUserResponses, PrepareTestScenarioData, PrepareTestScenarioErrors, PrepareTestScenarioResponses, PreviewAudienceCountData, PreviewAudienceCountErrors, PreviewAudienceCountResponses, PreviewAudienceMandatesPageData, PreviewAudienceMandatesPageErrors, PreviewAudienceMandatesPageResponses, PrintAclTestPrintAclPostData, PrintAclTestPrintAclPostErrors, PrintAclTestPrintAclPostResponses, ReadMessageData, ReadMessageErrors, ReadMessageResponses, ReauthWithPasswordData, ReauthWithPasswordErrors, ReauthWithPasswordResponses, ReauthWithSsoData, ReauthWithSsoErrors, ReauthWithSsoResponses, RefreshData, RefreshErrors, RefreshResponses, RemoveScopeFromUserData, RemoveScopeFromUserErrors, RemoveScopeFromUserResponses, RemoveUserRightFromMandateData, RemoveUserRightFromMandateErrors, RemoveUserRightFromMandateResponses, ResetMfaData, ResetMfaErrors, ResetMfaResponses, RevokeAllDevicesData, RevokeAllDevicesErrors, RevokeAllDevicesResponses, RevokeDeviceData, RevokeDeviceErrors, RevokeDeviceResponses, RootGetData, RootGetResponses, SaveAttendanceData, SaveAttendanceErrors, SaveAttendanceResponses, ScrapeCalendarEntriesData, ScrapeCalendarEntriesErrors, ScrapeCalendarEntriesResponses, SendAnonymousSupportMessageData, SendAnonymousSupportMessageErrors, SendAnonymousSupportMessageResponses, SendPasswordResetCodeData, SendPasswordResetCodeErrors, SendPasswordResetCodeResponses, SendSupportMessageData, SendSupportMessageErrors, SendSupportMessageResponses, SendUploadedFilesSummaryData, SendUploadedFilesSummaryErrors, SendUploadedFilesSummaryResponses, SetSettingsAdminSettingsPutData, SetSettingsAdminSettingsPutErrors, SetSettingsAdminSettingsPutResponses, StartMfaEmailChallengeData, StartMfaEmailChallengeErrors, StartMfaEmailChallengeResponses, StartReauthEmailChallengeData, StartReauthEmailChallengeErrors, StartReauthEmailChallengeResponses, StartVerifyEmailMfaMethodData, StartVerifyEmailMfaMethodErrors, StartVerifyEmailMfaMethodResponses, SubmitAttendanceData, SubmitAttendanceErrors, SubmitAttendanceResponses, SubscribeToPushData, SubscribeToPushErrors, SubscribeToPushResponses, SyncRestrictedMandateAccessData, SyncRestrictedMandateAccessErrors, SyncRestrictedMandateAccessResponses, TestPingData, TestPingErrors, TestPingResponses, UnsubmitAttendanceData, UnsubmitAttendanceErrors, UnsubmitAttendanceResponses, UnsubscribeFromPushData, UnsubscribeFromPushErrors, UnsubscribeFromPushResponses, UploadMultipleFilesData, UploadMultipleFilesErrors, UploadMultipleFilesResponses, UploadMultiplePspDocumentsData, UploadMultiplePspDocumentsErrors, UploadMultiplePspDocumentsResponses, UploadPopupImageData, UploadPopupImageErrors, UploadPopupImageResponses, VerifyEmailMfaMethodData, VerifyEmailMfaMethodErrors, VerifyEmailMfaMethodResponses, VerifyLoginMfaTotpData, VerifyLoginMfaTotpErrors, VerifyLoginMfaTotpResponses, VerifyMandateData, VerifyMandateErrors, VerifyMandateResponses, VerifyMfaEmailChallengeData, VerifyMfaEmailChallengeErrors, VerifyMfaEmailChallengeResponses, VerifyMfaTotpMethodData, VerifyMfaTotpMethodErrors, VerifyMfaTotpMethodResponses, VerifyReauthEmailChallengeData, VerifyReauthEmailChallengeErrors, VerifyReauthEmailChallengeResponses, VerifyUnusedBackupCodesData, VerifyUnusedBackupCodesErrors, VerifyUnusedBackupCodesResponses, VerifyUserData, VerifyUserErrors, VerifyUserResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Root
 */
export const rootGet = <ThrowOnError extends boolean = false>(options?: Options<RootGetData, ThrowOnError>) => (options?.client ?? client).get<RootGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/',
    ...options
});

/**
 * Login
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login Sso
 */
export const loginSso = <ThrowOnError extends boolean = false>(options: Options<LoginSsoData, ThrowOnError>) => (options.client ?? client).post<LoginSsoResponses, LoginSsoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/login_sso',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Password
 */
export const checkPassword = <ThrowOnError extends boolean = false>(options: Options<CheckPasswordData, ThrowOnError>) => (options.client ?? client).post<CheckPasswordResponses, CheckPasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/check_password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Password Policy
 */
export const getPasswordPolicy = <ThrowOnError extends boolean = false>(options?: Options<GetPasswordPolicyData, ThrowOnError>) => (options?.client ?? client).get<GetPasswordPolicyResponses, GetPasswordPolicyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/password_policy',
    ...options
});

/**
 * Change Password
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>) => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Expired Password
 */
export const changeExpiredPassword = <ThrowOnError extends boolean = false>(options: Options<ChangeExpiredPasswordData, ThrowOnError>) => (options.client ?? client).post<ChangeExpiredPasswordResponses, ChangeExpiredPasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/password/expired',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh
 */
export const refresh = <ThrowOnError extends boolean = false>(options?: Options<RefreshData, ThrowOnError>) => (options?.client ?? client).post<RefreshResponses, RefreshErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/refresh',
    ...options
});

/**
 * Change Password With Code
 */
export const changePasswordWithCode = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordWithCodeData, ThrowOnError>) => (options.client ?? client).post<ChangePasswordWithCodeResponses, ChangePasswordWithCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/change_password_with_code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Password Reset Code Is Valid
 */
export const passwordResetCodeIsValid = <ThrowOnError extends boolean = false>(options: Options<PasswordResetCodeIsValidData, ThrowOnError>) => (options.client ?? client).post<PasswordResetCodeIsValidResponses, PasswordResetCodeIsValidErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/password_reset_code_is_valid',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Password Reset Code
 */
export const sendPasswordResetCode = <ThrowOnError extends boolean = false>(options: Options<SendPasswordResetCodeData, ThrowOnError>) => (options.client ?? client).post<SendPasswordResetCodeResponses, SendPasswordResetCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/send_password_reset_code',
    ...options
});

/**
 * Get Mfa Methods
 */
export const getMfaMethods = <ThrowOnError extends boolean = false>(options?: Options<GetMfaMethodsData, ThrowOnError>) => (options?.client ?? client).get<GetMfaMethodsResponses, GetMfaMethodsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/method',
    ...options
});

/**
 * Create Totp Mfa Method
 */
export const createTotpMfaMethod = <ThrowOnError extends boolean = false>(options: Options<CreateTotpMfaMethodData, ThrowOnError>) => (options.client ?? client).post<CreateTotpMfaMethodResponses, CreateTotpMfaMethodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/method/totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Mfa Totp Method
 */
export const verifyMfaTotpMethod = <ThrowOnError extends boolean = false>(options: Options<VerifyMfaTotpMethodData, ThrowOnError>) => (options.client ?? client).post<VerifyMfaTotpMethodResponses, VerifyMfaTotpMethodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/method/{mfa_method_id}/verify/totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Mfa Method
 */
export const deleteMfaMethod = <ThrowOnError extends boolean = false>(options: Options<DeleteMfaMethodData, ThrowOnError>) => (options.client ?? client).delete<DeleteMfaMethodResponses, DeleteMfaMethodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/method/{mfa_method_id}',
    ...options
});

/**
 * Patch Mfa Method
 */
export const patchMfaMethod = <ThrowOnError extends boolean = false>(options: Options<PatchMfaMethodData, ThrowOnError>) => (options.client ?? client).patch<PatchMfaMethodResponses, PatchMfaMethodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/method/{mfa_method_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Email Mfa Method
 */
export const createEmailMfaMethod = <ThrowOnError extends boolean = false>(options: Options<CreateEmailMfaMethodData, ThrowOnError>) => (options.client ?? client).post<CreateEmailMfaMethodResponses, CreateEmailMfaMethodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/method/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Verify Email Mfa Method
 */
export const startVerifyEmailMfaMethod = <ThrowOnError extends boolean = false>(options: Options<StartVerifyEmailMfaMethodData, ThrowOnError>) => (options.client ?? client).post<StartVerifyEmailMfaMethodResponses, StartVerifyEmailMfaMethodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/method/{mfa_method_id}/verify/email/start',
    ...options
});

/**
 * Verify Email Mfa Method
 */
export const verifyEmailMfaMethod = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailMfaMethodData, ThrowOnError>) => (options.client ?? client).post<VerifyEmailMfaMethodResponses, VerifyEmailMfaMethodErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/method/{mfa_method_id}/verify/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Login Mfa Totp
 */
export const verifyLoginMfaTotp = <ThrowOnError extends boolean = false>(options: Options<VerifyLoginMfaTotpData, ThrowOnError>) => (options.client ?? client).post<VerifyLoginMfaTotpResponses, VerifyLoginMfaTotpErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/totp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Mfa Email Challenge
 */
export const startMfaEmailChallenge = <ThrowOnError extends boolean = false>(options: Options<StartMfaEmailChallengeData, ThrowOnError>) => (options.client ?? client).post<StartMfaEmailChallengeResponses, StartMfaEmailChallengeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/challenge/email/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Login Mfa Email Challenge
 */
export const verifyMfaEmailChallenge = <ThrowOnError extends boolean = false>(options: Options<VerifyMfaEmailChallengeData, ThrowOnError>) => (options.client ?? client).post<VerifyMfaEmailChallengeResponses, VerifyMfaEmailChallengeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/challenge/email/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Unused Backup Code
 */
export const verifyUnusedBackupCodes = <ThrowOnError extends boolean = false>(options: Options<VerifyUnusedBackupCodesData, ThrowOnError>) => (options.client ?? client).post<VerifyUnusedBackupCodesResponses, VerifyUnusedBackupCodesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/backup_code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fresh Until
 */
export const freshUntil = <ThrowOnError extends boolean = false>(options?: Options<FreshUntilData, ThrowOnError>) => (options?.client ?? client).get<FreshUntilResponses, FreshUntilErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/fresh_until',
    ...options
});

/**
 * Reauth With Password
 */
export const reauthWithPassword = <ThrowOnError extends boolean = false>(options: Options<ReauthWithPasswordData, ThrowOnError>) => (options.client ?? client).post<ReauthWithPasswordResponses, ReauthWithPasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/reauth/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reauth With Sso
 */
export const reauthWithSso = <ThrowOnError extends boolean = false>(options: Options<ReauthWithSsoData, ThrowOnError>) => (options.client ?? client).post<ReauthWithSsoResponses, ReauthWithSsoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/reauth/sso',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Reauth Email Challenge
 */
export const startReauthEmailChallenge = <ThrowOnError extends boolean = false>(options: Options<StartReauthEmailChallengeData, ThrowOnError>) => (options.client ?? client).post<StartReauthEmailChallengeResponses, StartReauthEmailChallengeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/reauth/challenge/email/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Reauth Email Challenge
 */
export const verifyReauthEmailChallenge = <ThrowOnError extends boolean = false>(options: Options<VerifyReauthEmailChallengeData, ThrowOnError>) => (options.client ?? client).post<VerifyReauthEmailChallengeResponses, VerifyReauthEmailChallengeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/reauth/challenge/email/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke All Devices
 */
export const revokeAllDevices = <ThrowOnError extends boolean = false>(options?: Options<RevokeAllDevicesData, ThrowOnError>) => (options?.client ?? client).delete<RevokeAllDevicesResponses, RevokeAllDevicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/devices',
    ...options
});

/**
 * Get Devices
 */
export const getDevices = <ThrowOnError extends boolean = false>(options?: Options<GetDevicesData, ThrowOnError>) => (options?.client ?? client).get<GetDevicesResponses, GetDevicesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/devices',
    ...options
});

/**
 * Revoke Device
 */
export const revokeDevice = <ThrowOnError extends boolean = false>(options: Options<RevokeDeviceData, ThrowOnError>) => (options.client ?? client).delete<RevokeDeviceResponses, RevokeDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/devices/{device_id}',
    ...options
});

/**
 * Patch Device
 */
export const patchDevice = <ThrowOnError extends boolean = false>(options: Options<PatchDeviceData, ThrowOnError>) => (options.client ?? client).patch<PatchDeviceResponses, PatchDeviceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/devices/{device_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Mfa
 */
export const resetMfa = <ThrowOnError extends boolean = false>(options: Options<ResetMfaData, ThrowOnError>) => (options.client ?? client).post<ResetMfaResponses, ResetMfaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/mfa/reset',
    ...options
});

/**
 * End Impersonation
 */
export const endImpersonation = <ThrowOnError extends boolean = false>(options?: Options<EndImpersonationData, ThrowOnError>) => (options?.client ?? client).post<EndImpersonationResponses, EndImpersonationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/impersonate/end',
    ...options
});

/**
 * Impersonate User
 */
export const impersonateUser = <ThrowOnError extends boolean = false>(options: Options<ImpersonateUserData, ThrowOnError>) => (options.client ?? client).post<ImpersonateUserResponses, ImpersonateUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/impersonate/{user_id}',
    ...options
});

/**
 * Get Users
 *
 * @deprecated
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>) => (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/',
    ...options
});

/**
 * Patch User
 */
export const patchUser = <ThrowOnError extends boolean = false>(options: Options<PatchUserData, ThrowOnError>) => (options.client ?? client).patch<PatchUserResponses, PatchUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create User
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) => (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read User Count
 *
 * @deprecated
 */
export const getUserCount = <ThrowOnError extends boolean = false>(options?: Options<GetUserCountData, ThrowOnError>) => (options?.client ?? client).get<GetUserCountResponses, GetUserCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/count',
    ...options
});

/**
 * Read Users Me
 */
export const getUserMe = <ThrowOnError extends boolean = false>(options?: Options<GetUserMeData, ThrowOnError>) => (options?.client ?? client).get<GetUserMeResponses, GetUserMeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me',
    ...options
});

/**
 * Delete User
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/{user_id}',
    ...options
});

/**
 * Read User By Id
 */
export const getUserById = <ThrowOnError extends boolean = false>(options: Options<GetUserByIdData, ThrowOnError>) => (options.client ?? client).get<GetUserByIdResponses, GetUserByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/{user_id}',
    ...options
});

/**
 * Patch User Admin
 */
export const patchUserAdmin = <ThrowOnError extends boolean = false>(options: Options<PatchUserAdminData, ThrowOnError>) => (options.client ?? client).patch<PatchUserAdminResponses, PatchUserAdminErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify User
 */
export const verifyUser = <ThrowOnError extends boolean = false>(options: Options<VerifyUserData, ThrowOnError>) => (options.client ?? client).post<VerifyUserResponses, VerifyUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate User Password
 */
export const generateUserPassword = <ThrowOnError extends boolean = false>(options: Options<GenerateUserPasswordData, ThrowOnError>) => (options.client ?? client).post<GenerateUserPasswordResponses, GenerateUserPasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/generate_password/{user_id}',
    ...options
});

/**
 * Add Scope To User
 */
export const addScopeToUser = <ThrowOnError extends boolean = false>(options: Options<AddScopeToUserData, ThrowOnError>) => (options.client ?? client).put<AddScopeToUserResponses, AddScopeToUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/{user_id}/scope/add/{scope}',
    ...options
});

/**
 * Remove Scope From User
 */
export const removeScopeFromUser = <ThrowOnError extends boolean = false>(options: Options<RemoveScopeFromUserData, ThrowOnError>) => (options.client ?? client).put<RemoveScopeFromUserResponses, RemoveScopeFromUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/{user_id}/scope/remove/{scope}',
    ...options
});

/**
 * Mandate Rights
 */
export const mandateRightsUserMandateRightsUserIdGet = <ThrowOnError extends boolean = false>(options: Options<MandateRightsUserMandateRightsUserIdGetData, ThrowOnError>) => (options.client ?? client).get<MandateRightsUserMandateRightsUserIdGetResponses, MandateRightsUserMandateRightsUserIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/mandate_rights/{user_id}',
    ...options
});

/**
 * Get Health
 */
export const getHealthHealthPingGet = <ThrowOnError extends boolean = false>(options?: Options<GetHealthHealthPingGetData, ThrowOnError>) => (options?.client ?? client).get<GetHealthHealthPingGetResponses, GetHealthHealthPingGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/health/ping',
    ...options
});

/**
 * Get Messages
 */
export const getMessages = <ThrowOnError extends boolean = false>(options: Options<GetMessagesData, ThrowOnError>) => (options.client ?? client).get<GetMessagesResponses, GetMessagesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/',
    ...options
});

/**
 * Create Message
 */
export const createMessage = <ThrowOnError extends boolean = false>(options: Options<CreateMessageData, ThrowOnError>) => (options.client ?? client).post<CreateMessageResponses, CreateMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Message Count
 */
export const getMessageCount = <ThrowOnError extends boolean = false>(options?: Options<GetMessageCountData, ThrowOnError>) => (options?.client ?? client).get<GetMessageCountResponses, GetMessageCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/count',
    ...options
});

/**
 * Get Messages Admin
 */
export const getMessagesAdmin = <ThrowOnError extends boolean = false>(options: Options<GetMessagesAdminData, ThrowOnError>) => (options.client ?? client).get<GetMessagesAdminResponses, GetMessagesAdminErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/admin',
    ...options
});

/**
 * Delete Message
 */
export const deleteMessage = <ThrowOnError extends boolean = false>(options: Options<DeleteMessageData, ThrowOnError>) => (options.client ?? client).delete<DeleteMessageResponses, DeleteMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/{message_id}',
    ...options
});

/**
 * Getmessagebyid
 */
export const getMessageById = <ThrowOnError extends boolean = false>(options: Options<GetMessageByIdData, ThrowOnError>) => (options.client ?? client).get<GetMessageByIdResponses, GetMessageByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/{message_id}',
    ...options
});

/**
 * Patch Message
 */
export const patchMessage = <ThrowOnError extends boolean = false>(options: Options<PatchMessageData, ThrowOnError>) => (options.client ?? client).patch<PatchMessageResponses, PatchMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/{message_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Readmessage
 */
export const readMessage = <ThrowOnError extends boolean = false>(options: Options<ReadMessageData, ThrowOnError>) => (options.client ?? client).post<ReadMessageResponses, ReadMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/read/{message_id}',
    ...options
});

/**
 * Get Messages Admin Count
 */
export const getMessageAdminCount = <ThrowOnError extends boolean = false>(options?: Options<GetMessageAdminCountData, ThrowOnError>) => (options?.client ?? client).get<GetMessageAdminCountResponses, GetMessageAdminCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/message/admin/count',
    ...options
});

/**
 * Get Rights
 */
export const getRights = <ThrowOnError extends boolean = false>(options?: Options<GetRightsData, ThrowOnError>) => (options?.client ?? client).get<GetRightsResponses, GetRightsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/right/',
    ...options
});

/**
 * Create Right
 */
export const createRight = <ThrowOnError extends boolean = false>(options: Options<CreateRightData, ThrowOnError>) => (options.client ?? client).post<CreateRightResponses, CreateRightErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/right/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Is Right Deletable
 *
 * Check if a right can be deleted. A right is deletable if it is not used by any document.
 */
export const isRightDeletable = <ThrowOnError extends boolean = false>(options: Options<IsRightDeletableData, ThrowOnError>) => (options.client ?? client).get<IsRightDeletableResponses, IsRightDeletableErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/right/deletable/{right_id}',
    ...options
});

/**
 * Get Folder Rights
 */
export const getFolderRights = <ThrowOnError extends boolean = false>(options?: Options<GetFolderRightsData, ThrowOnError>) => (options?.client ?? client).get<GetFolderRightsResponses, GetFolderRightsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/right/folder_rights',
    ...options
});

/**
 * Delete Right
 */
export const deleteRight = <ThrowOnError extends boolean = false>(options: Options<DeleteRightData, ThrowOnError>) => (options.client ?? client).delete<DeleteRightResponses, DeleteRightErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/right/{right_id}',
    ...options
});

/**
 * Get Right
 */
export const getRight = <ThrowOnError extends boolean = false>(options: Options<GetRightData, ThrowOnError>) => (options.client ?? client).get<GetRightResponses, GetRightErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/right/{right_id}',
    ...options
});

/**
 * Patch Right
 */
export const patchRight = <ThrowOnError extends boolean = false>(options: Options<PatchRightData, ThrowOnError>) => (options.client ?? client).patch<PatchRightResponses, PatchRightErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/right/{right_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Languages
 */
export const getLanguagesLanguageLanguagesGet = <ThrowOnError extends boolean = false>(options?: Options<GetLanguagesLanguageLanguagesGetData, ThrowOnError>) => (options?.client ?? client).get<GetLanguagesLanguageLanguagesGetResponses, GetLanguagesLanguageLanguagesGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/language/languages',
    ...options
});

/**
 * Get Mandates
 */
export const getMandates = <ThrowOnError extends boolean = false>(options?: Options<GetMandatesData, ThrowOnError>) => (options?.client ?? client).get<GetMandatesResponses, GetMandatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mandate/',
    ...options
});

/**
 * Create Mandate
 */
export const createMandate = <ThrowOnError extends boolean = false>(options: Options<CreateMandateData, ThrowOnError>) => (options.client ?? client).post<CreateMandateResponses, CreateMandateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mandate/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Mandate Count
 */
export const getMandateCount = <ThrowOnError extends boolean = false>(options?: Options<GetMandateCountData, ThrowOnError>) => (options?.client ?? client).get<GetMandateCountResponses, GetMandateCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mandate/count',
    ...options
});

/**
 * Get User Rights By Mandate Id
 */
export const getUserRightsByMandateId = <ThrowOnError extends boolean = false>(options: Options<GetUserRightsByMandateIdData, ThrowOnError>) => (options.client ?? client).get<GetUserRightsByMandateIdResponses, GetUserRightsByMandateIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mandate/user_rights/{mandate_id}',
    ...options
});

/**
 * Get My Mandates
 */
export const getMyMandates = <ThrowOnError extends boolean = false>(options?: Options<GetMyMandatesData, ThrowOnError>) => (options?.client ?? client).get<GetMyMandatesResponses, GetMyMandatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mandate/my',
    ...options
});

/**
 * Get Mandate By Id
 */
export const getMandateById = <ThrowOnError extends boolean = false>(options: Options<GetMandateByIdData, ThrowOnError>) => (options.client ?? client).get<GetMandateByIdResponses, GetMandateByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mandate/{mandate_id}',
    ...options
});

/**
 * Patch Mandate
 */
export const patchMandate = <ThrowOnError extends boolean = false>(options: Options<PatchMandateData, ThrowOnError>) => (options.client ?? client).patch<PatchMandateResponses, PatchMandateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mandate/{mandate_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Mandate
 */
export const verifyMandate = <ThrowOnError extends boolean = false>(options: Options<VerifyMandateData, ThrowOnError>) => (options.client ?? client).post<VerifyMandateResponses, VerifyMandateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mandate/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add User Right To Mandate
 */
export const addUserRightToMandate = <ThrowOnError extends boolean = false>(options: Options<AddUserRightToMandateData, ThrowOnError>) => (options.client ?? client).put<AddUserRightToMandateResponses, AddUserRightToMandateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user_mandate/{mandate_id}/add/right/{right_id}/{user_id}',
    ...options
});

/**
 * Remove User Right From Mandate
 */
export const removeUserRightFromMandate = <ThrowOnError extends boolean = false>(options: Options<RemoveUserRightFromMandateData, ThrowOnError>) => (options.client ?? client).put<RemoveUserRightFromMandateResponses, RemoveUserRightFromMandateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user_mandate/{mandate_id}/remove/right/{user_id}',
    ...options
});

/**
 * Get Tags
 */
export const getTags = <ThrowOnError extends boolean = false>(options?: Options<GetTagsData, ThrowOnError>) => (options?.client ?? client).get<GetTagsResponses, GetTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tag/',
    ...options
});

/**
 * Preview Audience Count
 */
export const previewAudienceCount = <ThrowOnError extends boolean = false>(options: Options<PreviewAudienceCountData, ThrowOnError>) => (options.client ?? client).post<PreviewAudienceCountResponses, PreviewAudienceCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audience/count',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Audience Mandates Page
 */
export const previewAudienceMandatesPage = <ThrowOnError extends boolean = false>(options: Options<PreviewAudienceMandatesPageData, ThrowOnError>) => (options.client ?? client).post<PreviewAudienceMandatesPageResponses, PreviewAudienceMandatesPageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audience/mandates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Audience Mandates Page
 */
export const getAudienceMandatesPage = <ThrowOnError extends boolean = false>(options: Options<GetAudienceMandatesPageData, ThrowOnError>) => (options.client ?? client).get<GetAudienceMandatesPageResponses, GetAudienceMandatesPageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audience/{audience_id}/mandates',
    ...options
});

/**
 * Get Audience Templates
 */
export const getAudienceTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetAudienceTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetAudienceTemplatesResponses, GetAudienceTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audience_template/',
    ...options
});

/**
 * Create Audience Template
 */
export const createAudienceTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateAudienceTemplateData, ThrowOnError>) => (options.client ?? client).post<CreateAudienceTemplateResponses, CreateAudienceTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audience_template/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Audience Template
 */
export const deleteAudienceTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteAudienceTemplateData, ThrowOnError>) => (options.client ?? client).delete<DeleteAudienceTemplateResponses, DeleteAudienceTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audience_template/{audience_template_id}',
    ...options
});

/**
 * Get Audience Template
 */
export const getAudienceTemplate = <ThrowOnError extends boolean = false>(options: Options<GetAudienceTemplateData, ThrowOnError>) => (options.client ?? client).get<GetAudienceTemplateResponses, GetAudienceTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audience_template/{audience_template_id}',
    ...options
});

/**
 * Patch Audience Template
 */
export const patchAudienceTemplate = <ThrowOnError extends boolean = false>(options: Options<PatchAudienceTemplateData, ThrowOnError>) => (options.client ?? client).patch<PatchAudienceTemplateResponses, PatchAudienceTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/audience_template/{audience_template_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Upload Limits
 */
export const getUploadLimits = <ThrowOnError extends boolean = false>(options?: Options<GetUploadLimitsData, ThrowOnError>) => (options?.client ?? client).get<GetUploadLimitsResponses, GetUploadLimitsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/limits',
    ...options
});

/**
 * Upload Multiple Files
 */
export const uploadMultipleFiles = <ThrowOnError extends boolean = false>(options: Options<UploadMultipleFilesData, ThrowOnError>) => (options.client ?? client).post<UploadMultipleFilesResponses, UploadMultipleFilesErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/multiple/{mandate_id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Upload
 */
export const deleteUpload = <ThrowOnError extends boolean = false>(options: Options<DeleteUploadData, ThrowOnError>) => (options.client ?? client).delete<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/{upload_id}',
    ...options
});

/**
 * Get My Uploads
 *
 * Get all uploads.
 *
 * @deprecated
 */
export const getMyUploads = <ThrowOnError extends boolean = false>(options: Options<GetMyUploadsData, ThrowOnError>) => (options.client ?? client).get<GetMyUploadsResponses, GetMyUploadsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/my',
    ...options
});

/**
 * Get My Upload Count
 *
 * Get the amount of total uploads.
 *
 * @deprecated
 */
export const getMyUploadCount = <ThrowOnError extends boolean = false>(options: Options<GetMyUploadCountData, ThrowOnError>) => (options.client ?? client).get<GetMyUploadCountResponses, GetMyUploadCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/my/count',
    ...options
});

/**
 * Get Uploads
 *
 * Get all uploads.
 *
 * @deprecated
 */
export const getUploads = <ThrowOnError extends boolean = false>(options: Options<GetUploadsData, ThrowOnError>) => (options.client ?? client).get<GetUploadsResponses, GetUploadsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/',
    ...options
});

/**
 * Get Upload Count
 *
 * Get the amount of total uploads.
 *
 * @deprecated
 */
export const getUploadCount = <ThrowOnError extends boolean = false>(options?: Options<GetUploadCountData, ThrowOnError>) => (options?.client ?? client).get<GetUploadCountResponses, GetUploadCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/count',
    ...options
});

/**
 * Download Upload
 *
 * Download a specific upload by its ID.
 */
export const downloadUpload = <ThrowOnError extends boolean = false>(options: Options<DownloadUploadData, ThrowOnError>) => (options.client ?? client).get<DownloadUploadResponses, DownloadUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/download/{upload_id}',
    ...options
});

/**
 * Is Upload Deletable
 */
export const isUploadDeletable = <ThrowOnError extends boolean = false>(options: Options<IsUploadDeletableData, ThrowOnError>) => (options.client ?? client).get<IsUploadDeletableResponses, IsUploadDeletableErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/upload/deletable/{upload_id}',
    ...options
});

/**
 * Get Mandate Structure
 */
export const getMandateStructure = <ThrowOnError extends boolean = false>(options: Options<GetMandateStructureData, ThrowOnError>) => (options.client ?? client).get<GetMandateStructureResponses, GetMandateStructureErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/download/mandate/{mandate_id}',
    ...options
});

/**
 * Download File
 *
 * Download a file by its path.
 */
export const downloadFile = <ThrowOnError extends boolean = false>(options: Options<DownloadFileData, ThrowOnError>) => (options.client ?? client).get<DownloadFileResponses, DownloadFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/download/file',
    ...options
});

/**
 * Get Calendar Entries
 *
 * Get the calendar import data.
 */
export const getCalendarEntries = <ThrowOnError extends boolean = false>(options: Options<GetCalendarEntriesData, ThrowOnError>) => (options.client ?? client).get<GetCalendarEntriesResponses, GetCalendarEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/calendar/calendar',
    ...options
});

/**
 * Import Arxivar
 */
export const importArxivar = <ThrowOnError extends boolean = false>(options?: Options<ImportArxivarData, ThrowOnError>) => (options?.client ?? client).post<ImportArxivarResponses, ImportArxivarErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/import_arxivar',
    ...options
});

/**
 * Import Arxivar Users
 */
export const importArxivarUsers = <ThrowOnError extends boolean = false>(options?: Options<ImportArxivarUsersData, ThrowOnError>) => (options?.client ?? client).post<ImportArxivarUsersResponses, ImportArxivarUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/import_arxivar_users',
    ...options
});

/**
 * Import Arxivar Mandates
 */
export const importArxivarMandates = <ThrowOnError extends boolean = false>(options?: Options<ImportArxivarMandatesData, ThrowOnError>) => (options?.client ?? client).post<ImportArxivarMandatesResponses, ImportArxivarMandatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/import_arxivar_mandates',
    ...options
});

/**
 * Import Arxivar Employees
 */
export const importArxivarEmployees = <ThrowOnError extends boolean = false>(options?: Options<ImportArxivarEmployeesData, ThrowOnError>) => (options?.client ?? client).post<ImportArxivarEmployeesResponses, ImportArxivarEmployeesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/import_arxivar_employees',
    ...options
});

/**
 * Import Psp Documents
 */
export const importPspDocuments = <ThrowOnError extends boolean = false>(options?: Options<ImportPspDocumentsData, ThrowOnError>) => (options?.client ?? client).post<ImportPspDocumentsResponses, ImportPspDocumentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/import_psp_documents',
    ...options
});

/**
 * Scrape Calendar Entries
 */
export const scrapeCalendarEntries = <ThrowOnError extends boolean = false>(options?: Options<ScrapeCalendarEntriesData, ThrowOnError>) => (options?.client ?? client).post<ScrapeCalendarEntriesResponses, ScrapeCalendarEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/scrape_calendar_entries',
    ...options
});

/**
 * Import Circular Letters
 */
export const importCircularLetters = <ThrowOnError extends boolean = false>(options?: Options<ImportCircularLettersData, ThrowOnError>) => (options?.client ?? client).post<ImportCircularLettersResponses, ImportCircularLettersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/import_circular_letters',
    ...options
});

/**
 * Send Uploaded Files Summary
 */
export const sendUploadedFilesSummary = <ThrowOnError extends boolean = false>(options?: Options<SendUploadedFilesSummaryData, ThrowOnError>) => (options?.client ?? client).post<SendUploadedFilesSummaryResponses, SendUploadedFilesSummaryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/send_uploaded_files_summary',
    ...options
});

/**
 * Import Arxivar Documents
 */
export const importArxivarDocuments = <ThrowOnError extends boolean = false>(options?: Options<ImportArxivarDocumentsData, ThrowOnError>) => (options?.client ?? client).post<ImportArxivarDocumentsResponses, ImportArxivarDocumentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/import_arxivar_documents',
    ...options
});

/**
 * Sync Restricted Mandate Access
 */
export const syncRestrictedMandateAccess = <ThrowOnError extends boolean = false>(options?: Options<SyncRestrictedMandateAccessData, ThrowOnError>) => (options?.client ?? client).post<SyncRestrictedMandateAccessResponses, SyncRestrictedMandateAccessErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/sync_restricted_mandate_access',
    ...options
});

/**
 * Import Attendance Emails
 */
export const importAttendanceEmails = <ThrowOnError extends boolean = false>(options?: Options<ImportAttendanceEmailsData, ThrowOnError>) => (options?.client ?? client).post<ImportAttendanceEmailsResponses, ImportAttendanceEmailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/task/import_attendance_emails',
    ...options
});

/**
 * Get Circular Letters
 */
export const getCircularLetters = <ThrowOnError extends boolean = false>(options?: Options<GetCircularLettersData, ThrowOnError>) => (options?.client ?? client).get<GetCircularLettersResponses, GetCircularLettersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/circular_letter/',
    ...options
});

/**
 * Get Circular Letter Pds
 */
export const getCircularLetterPdf = <ThrowOnError extends boolean = false>(options: Options<GetCircularLetterPdfData, ThrowOnError>) => (options.client ?? client).get<GetCircularLetterPdfResponses, GetCircularLetterPdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/circular_letter/pdf/{circular_letter_id}',
    ...options
});

/**
 * Subscribe
 */
export const subscribeToPush = <ThrowOnError extends boolean = false>(options: Options<SubscribeToPushData, ThrowOnError>) => (options.client ?? client).post<SubscribeToPushResponses, SubscribeToPushErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/push/subscribe',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unsubscribe
 */
export const unsubscribeFromPush = <ThrowOnError extends boolean = false>(options: Options<UnsubscribeFromPushData, ThrowOnError>) => (options.client ?? client).post<UnsubscribeFromPushResponses, UnsubscribeFromPushErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/push/unsubscribe',
    ...options
});

/**
 * Get Psp Documents
 *
 * @deprecated
 */
export const getPspDocuments = <ThrowOnError extends boolean = false>(options: Options<GetPspDocumentsData, ThrowOnError>) => (options.client ?? client).get<GetPspDocumentsResponses, GetPspDocumentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psp_document/',
    ...options
});

/**
 * Get Psp Document Count
 *
 * @deprecated
 */
export const getPspDocumentCount = <ThrowOnError extends boolean = false>(options: Options<GetPspDocumentCountData, ThrowOnError>) => (options.client ?? client).get<GetPspDocumentCountResponses, GetPspDocumentCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psp_document/count',
    ...options
});

/**
 * Get All Psp Documents
 *
 * @deprecated
 */
export const getAllPspDocuments = <ThrowOnError extends boolean = false>(options?: Options<GetAllPspDocumentsData, ThrowOnError>) => (options?.client ?? client).get<GetAllPspDocumentsResponses, GetAllPspDocumentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psp_document/all',
    ...options
});

/**
 * Get All Psp Document Count
 *
 * @deprecated
 */
export const getAllPspDocumentCount = <ThrowOnError extends boolean = false>(options?: Options<GetAllPspDocumentCountData, ThrowOnError>) => (options?.client ?? client).get<GetAllPspDocumentCountResponses, GetAllPspDocumentCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psp_document/count/all',
    ...options
});

/**
 * Download Document
 */
export const downloadPspDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadPspDocumentData, ThrowOnError>) => (options.client ?? client).get<DownloadPspDocumentResponses, DownloadPspDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psp_document/download/{document_id}',
    ...options
});

/**
 * Delete Psp Document
 */
export const deletePspDocument = <ThrowOnError extends boolean = false>(options: Options<DeletePspDocumentData, ThrowOnError>) => (options.client ?? client).delete<DeletePspDocumentResponses, DeletePspDocumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psp_document/delete',
    ...options
});

/**
 * Upload Multiple Psp Documents
 *
 * Upload multiple files into a specific folder for a mandate.
 */
export const uploadMultiplePspDocuments = <ThrowOnError extends boolean = false>(options: Options<UploadMultiplePspDocumentsData, ThrowOnError>) => (options.client ?? client).post<UploadMultiplePspDocumentsResponses, UploadMultiplePspDocumentsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psp_document/upload/multiple',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Notifications
 */
export const getNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsData, ThrowOnError>) => (options?.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notification/',
    ...options
});

/**
 * Mark Notifications As Read
 */
export const markNotificationsAsRead = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationsAsReadData, ThrowOnError>) => (options.client ?? client).post<MarkNotificationsAsReadResponses, MarkNotificationsAsReadErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notification/mark_as_read',
    ...options
});

/**
 * Mark Notifications As Unread
 */
export const markNotificationsAsUnRead = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationsAsUnReadData, ThrowOnError>) => (options.client ?? client).post<MarkNotificationsAsUnReadResponses, MarkNotificationsAsUnReadErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notification/mark_as_unread',
    ...options
});

/**
 * Mark All Notifications As Read
 */
export const markAllNotificationsAsRead = <ThrowOnError extends boolean = false>(options?: Options<MarkAllNotificationsAsReadData, ThrowOnError>) => (options?.client ?? client).post<MarkAllNotificationsAsReadResponses, MarkAllNotificationsAsReadErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notification/mark_all_as_read',
    ...options
});

/**
 * Get Unread Notification Count
 */
export const getUnreadNotificationCount = <ThrowOnError extends boolean = false>(options?: Options<GetUnreadNotificationCountData, ThrowOnError>) => (options?.client ?? client).get<GetUnreadNotificationCountResponses, GetUnreadNotificationCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notification/count',
    ...options
});

/**
 * Delete Notification
 */
export const deleteNotification = <ThrowOnError extends boolean = false>(options: Options<DeleteNotificationData, ThrowOnError>) => (options.client ?? client).delete<DeleteNotificationResponses, DeleteNotificationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notification/{notification_id}',
    ...options
});

/**
 * Get Templates
 */
export const getTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetTemplatesResponses, GetTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/template/',
    ...options
});

/**
 * Create Template
 */
export const createTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateTemplateData, ThrowOnError>) => (options.client ?? client).post<CreateTemplateResponses, CreateTemplateErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/template/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Template Count
 */
export const getTemplateCount = <ThrowOnError extends boolean = false>(options?: Options<GetTemplateCountData, ThrowOnError>) => (options?.client ?? client).get<GetTemplateCountResponses, GetTemplateCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/template/count',
    ...options
});

/**
 * Delete Template
 */
export const deleteTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteTemplateData, ThrowOnError>) => (options.client ?? client).delete<DeleteTemplateResponses, DeleteTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/template/{template_id}',
    ...options
});

/**
 * Get Template
 */
export const getTemplate = <ThrowOnError extends boolean = false>(options: Options<GetTemplateData, ThrowOnError>) => (options.client ?? client).get<GetTemplateResponses, GetTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/template/{template_id}',
    ...options
});

/**
 * Download Template
 */
export const downloadTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadTemplateData, ThrowOnError>) => (options.client ?? client).get<DownloadTemplateResponses, DownloadTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/template/download/{template_id}',
    ...options
});

/**
 * Send Anonymous Support Message
 */
export const sendAnonymousSupportMessage = <ThrowOnError extends boolean = false>(options: Options<SendAnonymousSupportMessageData, ThrowOnError>) => (options.client ?? client).post<SendAnonymousSupportMessageResponses, SendAnonymousSupportMessageErrors, ThrowOnError>({
    responseType: 'json',
    url: '/support_message/anonymous',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Support Message
 */
export const sendSupportMessage = <ThrowOnError extends boolean = false>(options: Options<SendSupportMessageData, ThrowOnError>) => (options.client ?? client).post<SendSupportMessageResponses, SendSupportMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support_message/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Settings
 */
export const getSettingsAdminSettingsGet = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsAdminSettingsGetData, ThrowOnError>) => (options?.client ?? client).get<GetSettingsAdminSettingsGetResponses, GetSettingsAdminSettingsGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/admin/settings',
    ...options
});

/**
 * Set Settings
 */
export const setSettingsAdminSettingsPut = <ThrowOnError extends boolean = false>(options: Options<SetSettingsAdminSettingsPutData, ThrowOnError>) => (options.client ?? client).put<SetSettingsAdminSettingsPutResponses, SetSettingsAdminSettingsPutErrors, ThrowOnError>({
    responseType: 'json',
    url: '/admin/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Upload Files Summary
 */
export const getUploadFilesSummaryAdminUploadFilesSummaryGet = <ThrowOnError extends boolean = false>(options?: Options<GetUploadFilesSummaryAdminUploadFilesSummaryGetData, ThrowOnError>) => (options?.client ?? client).get<GetUploadFilesSummaryAdminUploadFilesSummaryGetResponses, GetUploadFilesSummaryAdminUploadFilesSummaryGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/upload_files_summary',
    ...options
});

/**
 * Expire Own Password
 */
export const expireOwnPassword = <ThrowOnError extends boolean = false>(options: Options<ExpireOwnPasswordData, ThrowOnError>) => (options.client ?? client).post<ExpireOwnPasswordResponses, ExpireOwnPasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/expire_password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Current Attendance
 */
export const getCurrentAttendance = <ThrowOnError extends boolean = false>(options: Options<GetCurrentAttendanceData, ThrowOnError>) => (options.client ?? client).get<GetCurrentAttendanceResponses, GetCurrentAttendanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/current',
    ...options
});

/**
 * Get Original Attendance
 */
export const getOriginalAttendance = <ThrowOnError extends boolean = false>(options: Options<GetOriginalAttendanceData, ThrowOnError>) => (options.client ?? client).get<GetOriginalAttendanceResponses, GetOriginalAttendanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/original',
    ...options
});

/**
 * Get Attendance
 */
export const getAttendanceById = <ThrowOnError extends boolean = false>(options: Options<GetAttendanceByIdData, ThrowOnError>) => (options.client ?? client).get<GetAttendanceByIdResponses, GetAttendanceByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/version/{attendance_id}',
    ...options
});

/**
 * Save Attendance
 */
export const saveAttendance = <ThrowOnError extends boolean = false>(options: Options<SaveAttendanceData, ThrowOnError>) => (options.client ?? client).put<SaveAttendanceResponses, SaveAttendanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import Attendance
 */
export const importAttendance = <ThrowOnError extends boolean = false>(options: Options<ImportAttendanceData, ThrowOnError>) => (options.client ?? client).post<ImportAttendanceResponses, ImportAttendanceErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Submit Attendance
 */
export const submitAttendance = <ThrowOnError extends boolean = false>(options: Options<SubmitAttendanceData, ThrowOnError>) => (options.client ?? client).post<SubmitAttendanceResponses, SubmitAttendanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/submit/{attendance_id}',
    ...options
});

/**
 * Unsubmit Attendance
 */
export const unsubmitAttendance = <ThrowOnError extends boolean = false>(options: Options<UnsubmitAttendanceData, ThrowOnError>) => (options.client ?? client).post<UnsubmitAttendanceResponses, UnsubmitAttendanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/unsubmit/{attendance_id}',
    ...options
});

/**
 * Get Available Months
 */
export const getAvailableAttendanceMonths = <ThrowOnError extends boolean = false>(options: Options<GetAvailableAttendanceMonthsData, ThrowOnError>) => (options.client ?? client).get<GetAvailableAttendanceMonthsResponses, GetAvailableAttendanceMonthsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/months',
    ...options
});

/**
 * Get Versions
 */
export const getAttendanceVersions = <ThrowOnError extends boolean = false>(options: Options<GetAttendanceVersionsData, ThrowOnError>) => (options.client ?? client).get<GetAttendanceVersionsResponses, GetAttendanceVersionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/versions',
    ...options
});

/**
 * Get Available Voci
 */
export const getAvailableVoci = <ThrowOnError extends boolean = false>(options?: Options<GetAvailableVociData, ThrowOnError>) => (options?.client ?? client).get<GetAvailableVociResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/voci',
    ...options
});

/**
 * Get Available Giustificativi
 */
export const getAvailableGiustificativi = <ThrowOnError extends boolean = false>(options: Options<GetAvailableGiustificativiData, ThrowOnError>) => (options.client ?? client).get<GetAvailableGiustificativiResponses, GetAvailableGiustificativiErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/attendance/giustificativi/{mandate_id}',
    ...options
});

/**
 * Get Popups
 */
export const getPopups = <ThrowOnError extends boolean = false>(options?: Options<GetPopupsData, ThrowOnError>) => (options?.client ?? client).get<GetPopupsResponses, GetPopupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/',
    ...options
});

/**
 * Create Popup
 */
export const createPopup = <ThrowOnError extends boolean = false>(options: Options<CreatePopupData, ThrowOnError>) => (options.client ?? client).post<CreatePopupResponses, CreatePopupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Popup Image
 */
export const uploadPopupImage = <ThrowOnError extends boolean = false>(options: Options<UploadPopupImageData, ThrowOnError>) => (options.client ?? client).post<UploadPopupImageResponses, UploadPopupImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Popup Image
 */
export const getPopupImage = <ThrowOnError extends boolean = false>(options: Options<GetPopupImageData, ThrowOnError>) => (options.client ?? client).get<GetPopupImageResponses, GetPopupImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/image/{file_id}',
    ...options
});

/**
 * Get Popups To Display
 */
export const getPopupsToDisplay = <ThrowOnError extends boolean = false>(options: Options<GetPopupsToDisplayData, ThrowOnError>) => (options.client ?? client).get<GetPopupsToDisplayResponses, GetPopupsToDisplayErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/display',
    ...options
});

/**
 * Get Popup
 */
export const getPopup = <ThrowOnError extends boolean = false>(options: Options<GetPopupData, ThrowOnError>) => (options.client ?? client).get<GetPopupResponses, GetPopupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/{popup_id}',
    ...options
});

/**
 * Patch Popup
 */
export const patchPopup = <ThrowOnError extends boolean = false>(options: Options<PatchPopupData, ThrowOnError>) => (options.client ?? client).patch<PatchPopupResponses, PatchPopupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/{popup_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate Popup
 */
export const activatePopup = <ThrowOnError extends boolean = false>(options: Options<ActivatePopupData, ThrowOnError>) => (options.client ?? client).post<ActivatePopupResponses, ActivatePopupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/{popup_id}/activate',
    ...options
});

/**
 * Deactivate Popup
 */
export const deactivatePopup = <ThrowOnError extends boolean = false>(options: Options<DeactivatePopupData, ThrowOnError>) => (options.client ?? client).post<DeactivatePopupResponses, DeactivatePopupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/{popup_id}/deactivate',
    ...options
});

/**
 * Mark Popup As Viewed
 */
export const markPopupAsViewed = <ThrowOnError extends boolean = false>(options: Options<MarkPopupAsViewedData, ThrowOnError>) => (options.client ?? client).post<MarkPopupAsViewedResponses, MarkPopupAsViewedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/popup/{popup_id}/view',
    ...options
});

/**
 * Get Psp Documents Page
 */
export const getPspDocumentsPage = <ThrowOnError extends boolean = false>(options: Options<GetPspDocumentsPageData, ThrowOnError>) => (options.client ?? client).post<GetPspDocumentsPageResponses, GetPspDocumentsPageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/psp_document/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Psp Documents Page
 */
export const getAllPspDocumentsPage = <ThrowOnError extends boolean = false>(options: Options<GetAllPspDocumentsPageData, ThrowOnError>) => (options.client ?? client).post<GetAllPspDocumentsPageResponses, GetAllPspDocumentsPageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/psp_document/all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Uploads Page
 */
export const getMyUploadsPage = <ThrowOnError extends boolean = false>(options: Options<GetMyUploadsPageData, ThrowOnError>) => (options.client ?? client).post<GetMyUploadsPageResponses, GetMyUploadsPageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/upload/my',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Uploads Page
 */
export const getUploadsPage = <ThrowOnError extends boolean = false>(options: Options<GetUploadsPageData, ThrowOnError>) => (options.client ?? client).post<GetUploadsPageResponses, GetUploadsPageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/upload/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Users Page
 */
export const getUsersPage = <ThrowOnError extends boolean = false>(options: Options<GetUsersPageData, ThrowOnError>) => (options.client ?? client).post<GetUsersPageResponses, GetUsersPageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test Ping
 */
export const testPing = <ThrowOnError extends boolean = false>(options?: Options<TestPingData, ThrowOnError>) => (options?.client ?? client).get<TestPingResponses, TestPingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/test/ping',
    ...options
});

/**
 * Prepare Test Scenario
 */
export const prepareTestScenario = <ThrowOnError extends boolean = false>(options: Options<PrepareTestScenarioData, ThrowOnError>) => (options.client ?? client).post<PrepareTestScenarioResponses, PrepareTestScenarioErrors, ThrowOnError>({
    responseType: 'json',
    url: '/test/prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Print Acl
 */
export const printAclTestPrintAclPost = <ThrowOnError extends boolean = false>(options: Options<PrintAclTestPrintAclPostData, ThrowOnError>) => (options.client ?? client).post<PrintAclTestPrintAclPostResponses, PrintAclTestPrintAclPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/test/print_acl',
    ...options
});
